import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import type { GetTechTopicDTO } from '../service/ai-translation.repository.interface';
import { GetTechTopic } from '@/infrastructure/api-functions/interface/get-tech-topic.interface';
import { GetTechTopicRequest } from '@/services/ai-translation/type/ai-translation.type';

@injectable()
export class GetTechTopicDTOImpl implements GetTechTopicDTO {
    constructor(
        @inject(GetTechTopic)
        private readonly _getTechTopicApi: GetTechTopic,
    ) { }

    async fetch(value: GetTechTopicRequest): Promise<string> {
        const { tech_topic } = await this._getTechTopicApi.getTechTopic({
            input: value.input,
            source_lang: value.sourceLang,
            target_lang: value.targetLang,
            task_id: value.taskId,
            current_step: value.currentStep,
        });

        return tech_topic;
    }
}
